import React from "react";
import NotesIcon from "@mui/icons-material/Notes";
import { Container, RightContainer, Title } from "./styled";
import { useSelector } from "react-redux";
import moment from "moment";

const DataRevisao2Result = () => {
  const thisCard = useSelector((state) => state.card);

  const formattedDate = thisCard.dateRevisao2
    ? moment(thisCard.dateRevisao2).isValid()
      ? moment(thisCard.dateRevisao2).format("DD/MM/YYYY")
      : "-"
    : "";

  return (
    <Container>
      <NotesIcon fontSize="small" />
      <RightContainer>
        <Title>Data Revisão 2</Title>
        <p>{formattedDate}</p>
      </RightContainer>
    </Container>
  );
};

export default DataRevisao2Result;
